class ModalController {
    constructor($state, $modalInstance) {
        this.$state = $state;
        this.$modalInstance = $modalInstance;
    }

    filterOrder () {
        if (this.filtertext) {
            this.loading = true;
            return this.$state.go('app.admin.orders', { filtertype: this.filtertype, filtertext: this.filtertext }).then(() => {
                this.$modalInstance.close();
            });
        }
    }

    filterEvent () {
        let state = 'app.admin';
        switch (this.filtertype) {
            case 'treatment':
                state = `${state}.treatments`;
                break;
            case 'spaday':
                state = `${state}.days`;
                break;
            case 'option':
                state = `${state}.options`;
                break;
            case 'extra':
                state = `${state}.extras`;
                break;
        }

        return this.$state.go(state, { filtertext: this.filtertext }).then(() => {
            this.$modalInstance.close();
        });
    }

    canFilterText () {
        return ['id', 'customer.name', 'customer.email', 'reference'].some((allowed) => allowed === this.filtertype);
    }

    displayFiltertype () {
        switch (this.filtertype) {
            case 'id':
                return 'Order ID';
            case 'customer.name':
                return 'Customer Name';
            case 'customer.email':
                return 'Customer Email';
            case 'order_status_id':
                return 'Order Status';
            case 'payment_status_id':
                return 'Payment Status';
            case 'created_at':
                return 'Date created';
            case 'reference':
                return 'External Reference';
            case 'treatment':
                return 'Treatment';
            case 'spaday':
                return 'Spa Day';
            case 'option':
                return 'Mandatory Option';
            case 'extra':
                return 'Extra / Add on';
        }

        return '';
    }
}
ModalController.$inject = ['$state', '$modalInstance'];

export default ModalController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/controllers/modal.controller.js